<template>
    <layout-default :show-button-chat="false" :show-backpack="false">
      <div class="page-success">
        <div class="pdv-container">
          <div class="page-success-content">
            <div class="div-content">
              <img src="/images/featured/like-button.svg" class="btn-like" alt="git-sit">

              <h2>¡Te damos la bienvenida a PDV!</h2>

              <p>Te enviamos un mail a <span>example@email.com</span> con la confirmación de tu compra y toda la información de tus cursos.</p>

              <div class="but-content">
                <router-link :to="{name:'Landing'}" class="boton-new-primario boton-new-mediano w-full">
                  <img src="/images/featured/magicpen.svg" class="" alt="magicpen">
                  Inscribirse en otro programa
                </router-link>
                <a :href="ruleBook" download="ReglamentoPDV" target="_blank" class="boton-new-primario boton-new-mediano w-full">
                  <img src="/images/featured/document-download.svg" class="document-download" alt="git-sit">
                  Descargar reglamento de PDV
                </a>
              </div>

            </div>
            <div class="div-texture">
              <img src="/images/featured/girl-computer-sit-mobile.svg" class="only-mobile" alt="git-sit">
              <img src="/images/featured/girl-computer-sit.svg" class="only-desktop" alt="git-sit">
            </div>
          </div>
        </div>
      </div>
    </layout-default>
</template>

<script>
    import LayoutDefault from "@/layouts/Default"
    export default {

        computed:{

            studentEmail(){
                return this.$store.state.student.email
            },
            ruleBook() {
                return process.env.VUE_APP_PDV_RULEBOOK;
            }

        },

        components:{
            LayoutDefault
        },

        created() {
            this.$store.dispatch('cleanLocalStorage');
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

  .boton-new-primario{
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 100px;
    background-color: $morado50;
    border: solid 4px $neutralwhite;
    color: $neutralwhite;
    &:hover{
      background-color: $morado30;
    }
    &:active{
      background-color: $morado90;
    }
    &:focus{
      background-color: $morado50; 
      border: solid 4px grey;
    }
    &:disabled {
      background-color: #5924661a;
    }

    &.boton-new-largo{
      padding: 0 32px;
      height: 60px;
      width: auto;
      font-size: 20px;
      line-height: 28px;
    }
    &.boton-new-mediano{
      padding: 0 24px;
      height: 48px;
      width: auto;
      font-size: 16px;
      line-height: 18px;
    }
    &.boton-new-pequeno{
      padding: 0 16px;
      height: 32px;
      width: auto;
      font-size: 14px;
      line-height: 22px;
    }

    img{
      margin-right: 16px;
    }
  }

  .btn-like{
    width: 96px;
    height: 96px;
    margin-bottom: 24px;
  }

  .page-success {
    width: 100%;
    background: $amarrillo50;
  } 

  .page-success-content{
    display: flex;
    @media (max-width: 768px) {
      flex-direction: column;
      padding: 24px, 24px, 40px, 24px;
      gap: 32px;
    }
    @media (min-width: 769px) {
      flex-direction: row;
      padding: 40px 160px 56px 160px;
      gap: 48px;
    }
    .div-content{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      @media (max-width: 768px) {
        width: 100%;
        padding: 0 24px;
      }
      @media (min-width: 769px) {
        width: 50%;
        padding: 0 72px;
      }
      
      h2{
        font-family: 'Poppins-Bold', sans-serif;
        color: $colorTerciario !important;
        font-size: 22px;
        line-height: 32px;
        text-align: center;
      }

      p{
        font-family: 'Poppins-Regular', sans-serif;
        color: $neutral70 !important;
        font-size: 14px;
        line-height: 22px;
        text-align: center;
        margin-bottom: 0;
        span{
          font-weight: bold;
          font-family: 'Poppins-Regular', sans-serif;
          color: $neutral70 !important;
          font-size: 14px;
          line-height: 22px;
        }
      }

      .but-content{
        display: flex;
        flex-direction: column;
        gap: 16px;
        @media (max-width: 768px) {
          width: 100%;
          margin-top: 32px;
        }
        @media (min-width: 769px) {
         margin-top: 48px;
        }
      }
    }
    .div-texture{
      @media (max-width: 768px) {
        width: 100%;
        padding: 0 24px;
        margin-bottom: 40px;
        display: flex;
        flex-direction: column;
        align-items: center;

        img {
          width: 100%;
        }
      }
      @media (min-width: 769px) {
        width: 50%;
        
      }
    }
  }


    .success-inscription{
        padding-top: 120px;
        position: relative;
        height: 850px;
        background: $green;

        .main-content{
            padding-top: 75px;
            background-image: url(/images/foto-principal-inversa.png);
            background-repeat: no-repeat;
            background-position: right;
            background-size: contain;
            @include media-breakpoint-down(sm){
                padding-top: 0;
                background-image: none;
            }
            h3,h4,p{
                color: #fff;
            }

            .message-info-box{
                align-items: center;
                padding: 12px;
                img{
                    width: 35px;
                }
                h5{
                    font-size: 20px;
                    margin-bottom: 0;
                    @include alternative-regular;
                    @include media-breakpoint-down(sm){
                        font-size: 16px;
                    }
                }
            }
            h3{
                font-size: 42px;
                line-height: 48px;
                margin-bottom: 10px;
                @include alternative-bold;
                @include media-breakpoint-down(sm){
                    font-size: 35px;
                }
            }
            h4{
                font-size: 20px;
                line-height: 21px;
                @include alternative-medium-regular;
            }
            p{
                @include alternative-light-regular;
            }

            .btn-pdv-primary{
                margin-bottom: 25px;
                &:last-child{
                    margin-bottom: 0;
                }
            }

            .text-content{
                margin: 42px 0;
                p{
                    span{
                        @include alternative-bold;
                        font-size: 18px;
                    }
                }
            }
        }

        .image-bg-mobile{
            height: 394px;
            text-align: center;
            padding-top: 15px;
            margin-bottom: -100px;
            position: relative;
            z-index: 1;
            img{
                height: 100%;
            }
        }

    }

</style>